import React from 'react';
import { NavigateBefore } from '@mui/icons-material';
import SecondaryTextLink from '@/lib/components/Common/Links/SecondaryTextLink';
import { Typography } from '@mui/material';
import { useRouter } from 'next/navigation';
import { LOCALE_FIN } from '@/lib/helpers';

/**
 * Back link component.
 *
 * @param {Object} props - Component props.
 * @param {string} [props.children] - Children (text).
 * @param {string} [props.to] - Url to go back to. If not provided, will go back in history.
 * @returns {React.ReactElement} Back link JSX component.
 */
function BackLink({ children, to }: { children?: React.ReactNode; to?: string }) {
  const router = useRouter();

  return (
    <SecondaryTextLink
      onClick={() => {
        if (!to) {
          router.back();
        } else {
          router.push(to);
        }
      }}
      size="medium"
      startIcon={<NavigateBefore sx={{ width: '0.8125em', height: '0.8125em' }} />}
      sx={{
        padding: '0',
        span: {
          margin: '0',
        },
      }}
    >
      <Typography variant="body1" component="span">
        {children ?? LOCALE_FIN.BACK}
      </Typography>
    </SecondaryTextLink>
  );
}

export default BackLink;
